// models/Challenge.ts
import { z } from 'zod';

/* eslint-disable no-unused-vars */
export enum ChallengeStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    VIDEO_PROCESSED = 'video_processed',
    PUBLISHED = 'published',
    ACTIVE = 'active',
    INACTIVE = 'inactive', // Here as a hack when we take videos down
    JUDGING = 'judging',
    COMPLETED = 'completed',
    SCORING = 'scoring',
    FAILED = 'failed',
}
const ChallengeStatusEnum = z.nativeEnum(ChallengeStatus);

export enum ChallengeType {
    CHALLENGE = 'challenge',
    RESPONSE = 'response',
    JUDGE = 'judge',
}
const ChallengeTypeEnum = z.nativeEnum(ChallengeType);

const nullableString = () => z.string().nullable().optional();

export const ChallengeSchema = z
    .object({
        PK: z.string(),
        SK: z.string(),
        content_type: z.literal('challenge'),
        user_id: z.string(),
        challenge_id: z.string(),
        type_user_id: z.string(),
        title: nullableString(),
        video: nullableString(),
        objectFit: z.string().optional().default('contain'),
        thumbnail: nullableString(),
        thumbnail_alternates: z.array(z.string()).optional(),
        description: nullableString(),
        start_date: nullableString(),
        end_date: nullableString(),
        category: z.string().optional(),
        like_count: z.number().default(0),
        comment_count: z.number().default(0),
        response_count: z.number().default(0),
        view_count: z.number().default(0),
        trending_score: z.number().default(1),
        has_prize: z.boolean().default(false),
        prize: nullableString(),
        prize_photo: nullableString(),
        link_to_prize_details: nullableString(),
        video_of_prize: nullableString(),
        prize_video_thumbnail: nullableString(),
        prize_video_thumbnail_alternates: z.array(z.string()).optional(),
        prize_video_status: z.string().optional(),
        judges_prize: nullableString(),
        judges_prize_photo: nullableString(),
        link_to_judges_prize_details: nullableString(),
        judges_prize_video: nullableString(),
        judges_prize_video_thumbnail: nullableString(),
        judges_prize_video_thumbnail_alternates: z.array(z.string()).optional(),
        judges_prize_video_status: nullableString(),
        requirements: nullableString(),
        terms: nullableString(),
        status: ChallengeStatusEnum.default(ChallengeStatus.PENDING),
        video_status: z.string().optional(),
        type: z.nativeEnum(ChallengeType).default(ChallengeType.CHALLENGE),
        created_at: z.string(),
        updated_at: z.string(),
    })
    .strip(); // This is here to remove any extra fields like the old judge_end field

export type Challenge = z.infer<typeof ChallengeSchema>;
export type ChallengeStatusType = z.infer<typeof ChallengeSchema>['status'];
